intra_module.controller('GroupUnsubscribedCtrl', function($scope) {
	$scope.unsubscribe_collapse = false
});
